export const GET_APPLICATION_STATUS_DEF = "GET_APPLICATION_STATUS_DEF"
export const GET_APPLICATION_STATUS_DEF_SUCCESS = "GET_APPLICATION_STATUS_DEF_SUCCESS"
export const GET_APPLICATION_STATUS_DEF_FAIL = "GET_APPLICATION_STATUS_DEF_FAIL"

export const API_ERROR = "API_ERROR"
